import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { CouponHolder } from 'src/app/holders/coupon-holder';
import { CouponsService } from 'src/app/services/coupons.service';
import { CurrentOrderService } from 'src/app/services/current-order.service';
import { InitializationService } from 'src/app/services/initialization.service';
import { LocaleService } from 'src/app/services/locale.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-pick-coupon-dialog',
  templateUrl: './pick-coupon-dialog.component.html',
  styleUrls: ['./pick-coupon-dialog.component.scss']
})

export class PickCouponDialogComponent implements OnInit 
{

  coupons=Array<CouponHolder>();
  origin='';

  constructor(
    public dialogRef: MatDialogRef<PickCouponDialogComponent>,
    private couponsservice:CouponsService,
    public alertDialog: MatDialog,
    private localeservice:LocaleService,
    private currentorderservice:CurrentOrderService
  ) { }

  ngOnInit(): void 
  {
    this.coupons = this.couponsservice.getCoupons(this.currentorderservice.getCurrentPrice(false, false));
  }

  couponTap(coupon:CouponHolder)
  {
    if(coupon.Used === true)
    {
      this.alertDialog.open(AlertDialogComponent, 
      {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Alert.CouponUsed.Title"), 
          detail:this.localeservice.instantTranslation("Dialogs.Alert.CouponUsed.Detail"), 
          accept:this.localeservice.instantTranslation("Dialogs.Alert.CouponUsed.Accept") 
        }
      });
      
      return;
    }

    if(coupon.Available === false)
    {
      this.alertDialog.open(AlertDialogComponent, 
      {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Alert.CouponUnavailable.Title"), 
          detail:this.localeservice.instantTranslation("Dialogs.Alert.CouponUnavailable.Detail"), 
          accept:this.localeservice.instantTranslation("Dialogs.Alert.CouponUnavailable.Accept") 
        }
      });
      
      return;
    }

    if(coupon.FloorRejected === true)
    {
      this.alertDialog.open(AlertDialogComponent, 
      {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Alert.FloorRejected.Title"), 
          detail:`${this.localeservice.instantTranslation("Dialogs.Alert.FloorRejected.Detail")} ${this.localeservice.getCurrencyString(coupon.Blueprint.FloorValue)}.`, 
          accept:this.localeservice.instantTranslation("Dialogs.Alert.FloorRejected.Accept") 
        }
      });
      
      return;
    }

    this.currentorderservice.setCoupon(coupon);

    this.dialogRef.close("done");
  }
}
